/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'

import Modal from '../../../components/Modal'

import sadRobot from '../../../assets/img/components/sad_robot.svg'

/*
 * Props
 *
 * show
 * title
 * image
 * content
 * primaryTitle
 * primaryBtnPressed
 * ghostTitle
 * ghostBtnPressed
 */

export default class ErrorDialog extends Component {

    get image() {
        var image = this.props.image
        if (image == null) {
            image = sadRobot
        }
        return image
    }

    get primaryButton() {
        if (this.props.primaryTitle == null) {
            return ''
        }

        return (
            <div className="buttons">
                <button 
                    type="button"
                    className="trace-input"
                    onClick={this.props.primaryBtnPressed}>
                    { this.props.primaryTitle }
                </button>
            </div>
        )
    }

    get ghostButton() {
        if (this.props.ghostTitle == null) {
            return ''
        }

        return (
            <div className="buttons">
                <button 
                    type="button"
                    className="trace-input ghost"
                    onClick={this.props.ghostBtnPressed}>
                    { this.props.ghostTitle }
                </button>
            </div>
        )
    }

    render() {

        return (
            <div className="DefaultError">
                <Modal
                    title={this.props.title}
                    open={this.props.show}
                    hideCloseBtn={true}>
                    <div className="content">
                        { this.props.content }                       
                    </div>
                    { this.primaryButton }
                    { this.ghostButton }
                </Modal>
            </div>
        )
    }
}

